<template>
  <div>
    <div class="dasharea">
      <router-view></router-view>
    </div>
    <Navbar
      v-bind:showBrand="false"
      v-bind:navbarBottom="true"
      v-bind:showLogout="false"
      v-bind:items="sidebarItems"
      v-bind:replaceInsteadOfPush="true"
    />
  </div>
</template>

<script>
import Navbar from "../components/Navbar";

export default {
  name: "Dashboard",
  components: {
    Navbar
  },
  data() {
    return {
      sidebarItems: [
        { id: 1, item: { name: "Quizzing", to: "/dashboard" } },
        {
          id: 2,
          item: {
            name: "Teams",
            to: "/dashboard/teams",
            notificationGetter: "teamStore/showNotification"
          }
        },
        { id: 3, item: { name: "History", to: "/dashboard/history" } }
      ]
    };
  },
  created() {
    this.$store.dispatch("teamStore/loadJoinRequests", this);
  },
  destroyed() {}
};
</script>

<style scoped>
.container-fluid {
  padding-top: 0px;
  padding-bottom: 50px;
}
</style>
